module.exports = __webpack_public_path__ + "static/assets/4f5a40c10d07dbf9abbdfbbd352d2d4f.svg";